import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { translateResourceString } from '../../../util/translationUtility';
import ModalLink from '../../../addtoshoppinglist/ModalLink';
import { generateLoginPageWithReturnUrlLink } from '../../../util/loginPageLinkUtility'

const ProductTileAddToListLink = ({
    linkClass,
    isUserLoggedIn,
    toggleModal,
    variation,
    loginPageUrl
}) => {
    const [loginLink, updateLoginLink] = useState(loginPageUrl) 

    const titleText = isUserLoggedIn
        ? translateResourceString('/Wishlist/AddToList')
        : (translateResourceString('/Wishlist/LoginNote/TextBeforeLoginLink') + translateResourceString('/Wishlist/LoginNote/LoginLinkText')
            + " " + translateResourceString('/Wishlist/LoginNote/TextBeforeRegisterLink') + translateResourceString('/Wishlist/LoginNote/RegisterLinkText')
            + " " + translateResourceString('/Wishlist/LoginNote/TextAboveRegisterText'));

    useEffect(() => {
        updateLoginLink(generateLoginPageWithReturnUrlLink(loginPageUrl, variation.MasterItemNumber, true))
    });

    return (
        <ModalLink
            ClassName={linkClass}
            LinkText={""}
            SrText={translateResourceString('/Wishlist/AddToList')}
            TitleText={titleText}
            ToggleModal={(isOpen) => toggleModal(isOpen, variation, isUserLoggedIn)}
            ButtonClasses={"product-actions__btn product-actions__btn--transparent"}
            UseIconOnly={true}
            UseLoginLink={!isUserLoggedIn}
            LoginPageLink={loginLink}
        />
    );
}

ProductTileAddToListLink.propTypes = {
    linkClass: PropTypes.string.isRequired,
    isUserLoggedIn: PropTypes.bool.isRequired,
    toggleModal: PropTypes.func.isRequired,
    variation: PropTypes.object.isRequired,
    loginPageUrl: PropTypes.object.isRequired
};

export default ProductTileAddToListLink;